
import React, { Fragment, useState, useEffect } from 'react';
import { Button, Row, Col } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Field, reduxForm, change } from 'redux-form';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment-timezone';
import SpeechTerapyPDF from './SpeechTerapyPDF';
import { CKEditor } from '@ckeditor/ckeditor5-react';
//import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { calculateAgeParse } from '../../../../Utils/Patient';
import IconButton from '@material-ui/core/IconButton';
import { Modal } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const SpeechTerapyForm = ({ data, speechTerapyText, handlerSpeechTerapy }) => {

    const [historyData, setHistoryData] = useState(null);
    const [format, setFormat] = useState(null);
    const [formats, setFormats] = useState([]);
    const [disabledFormat, setDisabledFormat] = useState(false);
    const [showModalPDFSpeechTerapy, setShowModalPDFSpeechTerapy] = useState(false);

    const getTemplatesSpeechResults = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'formato-resultados-fonoaudiologia/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(dataRes => {
            setFormats(dataRes);
        }).catch(error => {
            console.log(error);
            setFormats([]);
        })
    }

    const addSpeechTerapy = async () => {
        let dataToSend = {
            id_admision: data.id_admision,
            id_historia: data.id_historia,
            texto: speechTerapyText
        }

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/create-fonoaudiologia', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataToSend)
        })
            .then(response => {
                if (response.status !== 500 && response.status !== 403) {
                    return response.text();
                }
                else {
                    throw new Error("Ha ocurrido un error en el servidor");
                }
            })
            .then(data => {
                printSpeechTerapy();
            })
            .catch((error) => {
                console.error('Error:', error);
                alert("Ha ocurrido un error guardando la Audiometria o Fonoaudiologia");
            });
    }

    const getSpeechTerapy = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/get-fonoaudiologia?id_admision=' + data.id_admision, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status !== 500 && response.status !== 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el servidor");
            }
        }).then(data => {
            if (data.historia != null && data.historia != undefined) {
                setHistoryData(data.historia);
                handlerSpeechTerapy(data.historia.fonoaudiologia);
                setDisabledFormat(true);
            }
            else {
                setHistoryData(null);
                handlerSpeechTerapy(null);
                setDisabledFormat(false);
            }
        }).catch((error) => {
            console.error('Error:', error);
            handlerSpeechTerapy(null);
            setDisabledFormat(true);
        });
    }

    const updateSpeechTerapy = async () => {
        let dataToSend = {
            id_hist_informes: historyData.id_hist_informes,
            texto: speechTerapyText
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/update-fonoaudiologia', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataToSend)
        }).then(response => {
            if (response.status !== 500 && response.status !== 403) {
                return response.text();
            }
            else {
                throw new Error("Ha ocurrido un error en el servidor");
            }
        }).then(data => {
            printSpeechTerapy();
            disableUpdate();
        }).catch((error) => {
            console.error('Error:', error);
            alert("Ha ocurrido un error guardando la Audiometria o Fonoaudiologia");
        });
    }

    const printSpeechTerapy = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + `historia-informe/consultar-pdf?id_admision=${data.id_admision}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(res => {
            let dataQuery = res.info;
            let perfil = JSON.parse(sessionStorage.getItem('clinica'));
            let genderDoctor = dataQuery.sexo_doctor;
            let prefixDoctor = 'Dr. ';
            switch (genderDoctor) {
                case 'Masculino':
                    prefixDoctor = 'Dr. ';
                    break;
                case 'Femenino':
                    prefixDoctor = 'Dra. ';
                    break;
            }
            let nameDoctor = prefixDoctor + dataQuery.nombre_doctor;
            let firmDoctor = process.env.REACT_APP_PUBLIC_URL + dataQuery.url_firma_doctor + '/' + sessionStorage.getItem('token');
            let nameService = dataQuery.servicio.servicios[0].nombre;
            let codigoService = dataQuery.servicio.servicios[0].codigo;
            let resultados = dataQuery.procedimiento.fonoaudiologia;
            let fecha_salida = dataQuery.procedimiento.fecha;
            let responsable = dataQuery.representante_legal[0] != undefined ? dataQuery.representante_legal[0].nombre_completo : "";
            let diagnostico = null;

            if (dataQuery.diagnostico != null) {
                if (dataQuery.diagnostico.diagnostico.diagnostico.length > 0) {
                    diagnostico = dataQuery.diagnostico.diagnostico.diagnostico;
                }
            }

            const dataPrint = {
                fullname: dataQuery.fullname,
                documentNumber: dataQuery.num_documento,
                typeDocument: dataQuery.tip_documento,
                profile: perfil,
                birthday: moment(dataQuery.fec_nacimiento).format('DD/MM/YYYY'),
                age: calculateAgeParse(dataQuery.fec_nacimiento),
                gender: dataQuery.sexo,
                address: dataQuery.direccion.direccion,
                city: dataQuery.direccion.ciudad,
                job: dataQuery.ocupacion,
                telephone: dataQuery.telefono1,
                cellphone: dataQuery.celular,
                nitThird: dataQuery.nit_tercero,
                nameThird: dataQuery.nombre_tercero,
                regime: dataQuery.regimen_paciente,
                urlLogo: sessionStorage.getItem('logoURL'),
                speechTerapy: resultados,
                nameDoctor: nameDoctor,
                specialtyDoctor: dataQuery.especialidad_doctor,
                medicalRegister: dataQuery.reg_medico,
                urlDoctorFirm: firmDoctor,
                nameService: nameService,
                codigoService: codigoService,
                dateAdmision: moment(dataQuery.fecha_admision).format('DD/MM/YYYY'),
                hourAdmision: moment(dataQuery.hora_admision, "HH:mm:ss").format('h:mm:ss a'),
                responsable: responsable,
                anamnesis: dataQuery.anamnesis,
                diagnostico: diagnostico,
                dateOutPatient: moment(fecha_salida).format('DD/MM/YYYY'),
                hourOutPatient: moment(fecha_salida).format('h:mm:ss a'),
                remitentDoctor: dataQuery.remitente
            };
            setShowModalPDFSpeechTerapy(true);
            SpeechTerapyPDF(dataPrint);
        }).catch(error => {
            console.log(error);
        });
    }

    const handleChangeFormat = (formatValue) => {
        setFormat(formatValue);
        handlerSpeechTerapy(formatValue.formato);
    }

    const enableUpdate = () => {
        setDisabledFormat(false);
    }

    const disableUpdate = () => {
        setDisabledFormat(true);
    }

    const cancelUpdate = () => {
        setFormat(null);
        handlerSpeechTerapy(historyData.fonoaudiologia);
        disableUpdate();
    }

    useEffect(() => {
        getTemplatesSpeechResults();
        getSpeechTerapy();
        console.log("id_admision", data.id_admision);
    }, []);

    return (
        <Fragment>
            <div className={"container-wraper-hc physical-exam-form"}>
                <Col md={12} sm={12}>
                    <div>
                        <div className="title-clinic-history">
                            <h4>Procedimiento Audiologico</h4>
                        </div>
                        <div>
                            <Row>
                                <Col md={6}>
                                    <br />
                                    <TextField
                                        className="medical-material-form__field"
                                        id="transcriptionFormat"
                                        label="Formato"
                                        select
                                        InputLabelProps={{
                                            style: { color: '#646777' }
                                        }}
                                        disabled={disabledFormat}
                                        value={format}
                                        onChange={(e) => {
                                            handleChangeFormat(e.target.value);
                                        }}
                                    >
                                        {formats.map((format) => {
                                            return <MenuItem key={format.id_formato} value={format}>{format.nombre}</MenuItem>
                                        })}
                                    </TextField>
                                </Col>
                            </Row>
                            <br /><br />

                            <div className="form" style={{ width: '100%' }}>
                                <div className="form__half" style={{ width: '100%' }}>
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Procedimiento</span>
                                        <div style={{ margin: 10 }}>
                                            <CKEditor
                                                disabled={disabledFormat}
                                                style={{ width: '100%', height: '200px' }}
                                                editor={ClassicEditor}
                                                data={speechTerapyText != null ? speechTerapyText : null}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    handlerSpeechTerapy(data)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {
                                disabledFormat == true ? <>
                                    <Button
                                        style={{ marginTop: 10 }}
                                        color="primary"
                                        onClick={() => {
                                            printSpeechTerapy();
                                        }}
                                    >
                                        Imprimir
                                    </Button>
                                </> : null
                            }
                        </div>

                        {showModalPDFSpeechTerapy ?
                            <Modal
                                open={showModalPDFSpeechTerapy}
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                                style={{ zIndex: 1000 }}
                            >
                                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                                    <IconButton style={{ float: 'right' }} onClick={() => {
                                        setShowModalPDFSpeechTerapy(false);
                                    }}>
                                        <CloseIcon />
                                    </IconButton>
                                    <iframe id="pdfV" width="1000" height="700" >
                                    </iframe>
                                </div>
                            </Modal>
                            : null}


                    </div>
                </Col>
            </div>
        </Fragment>
    )
}

export default reduxForm({
    form: `speech-terapy-form`, // a unique identifier for this form
})(withTranslation('common')(SpeechTerapyForm));




